import { useState } from 'react';
import { useOverlayContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
export function useUpdateDraft() {
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { showErrorToast } = useOverlayContext();
    const [loading, setLoading] = useState(false);
    return {
        loading,
        async updateDraft (param) {
            let { newDraft, onSuccess, onStartLoader, onStopLoader } = param;
            onStartLoader && onStartLoader();
            setLoading(true);
            const result = await handlePromise(api.draft.save(newDraft.toDTO()));
            onStopLoader && onStopLoader();
            setLoading(false);
            if (result.success) {
                onSuccess();
            } else {
                showErrorToast(commonTexts.toasts.failedToUpdateDraft(), 'update-draft-error');
            }
        }
    };
}
